import moment from 'moment-es6';

export function date(parameters) {
  const [date] = parameters;
  const moment_date = moment(date);
  return {
    date: moment_date.isValid() ? moment_date.format('L LT') : date
  };
}
